export const Accordion = 'atlantis-accordion';
export const AccordionItem = 'atlantis-accordion-item';